import { render, staticRenderFns } from "./LinkedAccounts.vue?vue&type=template&id=22692100&scoped=true"
import script from "./LinkedAccounts.vue?vue&type=script&lang=ts"
export * from "./LinkedAccounts.vue?vue&type=script&lang=ts"
import style0 from "./LinkedAccounts.vue?vue&type=style&index=0&id=22692100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22692100",
  null
  
)

export default component.exports